import { FieldType } from "@ngx-formly/core";
import { Component } from "@angular/core";

@Component({
  selector: "formly-null-type",
  template: "",
})
export class NullTypeComponent extends FieldType {}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
